<template>
  <div class="index-box">
    <div class="indexTopBox">
      <div class="imageListCardVideo">
        <img class="qiyeImg" :src="schoolList.siAchievementImg" />
        <div class="cssName">{{ schoolList.siName }}</div>
        <div>合作方式：{{ schoolList.siWay }}</div>
        <div>成果负责人：{{ schoolList.siAlumniName }}</div>
        <div>
          <img :src="btnGuankan" />
          <div class="cssName" style="margin-top: 5px">
            {{ schoolList.siEyes }}人看过
          </div>
        </div>
        <div></div>
        <div class="FirstLevelTitle">
          <div>成果详情</div>
        </div>
        <div class="card_tail" v-if="fengeList != ''">
          <div
            class="card_tail_content"
            v-for="(segment, index) in fengeList"
            :key="index"
          >
            {{ segment }}
          </div>
        </div>
        <div class="FirstLevelTitle">
          <div>成果照片</div>
        </div>

        <div class="activeDetailsDiv">
          <div
            class="clearfix"
            style="width: 225vw; display: flex; flex-direction: row"
          >
            <div
              class="activeDetails clearfix"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <div style="display: flex; flex-direction: row">
                <van-image
                  class="schoolImg"
                  :src="item"
                  @click="onImage(index)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="indexBtn" v-show="schoolList.siNum == 0" @click="onDocking">
      我要对接
    </div>

    <van-action-sheet v-model="docking" title="我要对接">
      <el-form
        :model="dockingForm"
        ref="dockingForm"
        style="padding: 0 20px 0 20px"
        :rules="dockingRules"
      >
        <el-form-item label="联系人" prop="name">
          <el-input
            v-model="dockingForm.name"
            placeholder="请输入联系人"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input
            v-model="dockingForm.phone"
            placeholder="请输入电话"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="合作意向" prop="content">
          <el-input
            v-model="dockingForm.content"
            placeholder="请输入合作意向"
            type="textarea"
            rows="8"
            maxlength="200"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="formDivBtnDiv">
        <button class="formDivBtn" @click="submit">提交</button>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import btnGuankan from "@/assets/image/btn_guankan_nor.png";
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      btnGuankan,
      schoolList: [],
      imgList: [],
      id: this.$route.query.id,
      userId: window.localStorage.getItem("user_id"),
      // userId: "43995354",
      docking: false,
      dockingForm: {},
      dockingRules: {
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入电话号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入合作意向", trigger: "blur" },
        ],
      },
      fengeList: [],
    };
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    // 科技成果获取--详情
    async getSchoolList() {
      const result = await this.$http.get(
        "/achievementTransform/AchievementByName",
        {
          params: { id: this.id, userId: this.userId },
        }
      );
      this.schoolList = result.data.AchievementByName;
      this.imgList = result.data.AchievementByName.siAchievementDoc.split(",");

      // 使用split方法根据关键字分割字符串
      const content = result.data.AchievementByName.siDescription.split("\n");
      // 重新组合分段，包含关键字
      const contentList = [];
      for (let i = 0; i < content.length; i++) {
        contentList.push(content[i]);
      }
      this.fengeList = contentList;

      console.log("图片", this.imgList.length);
    },

    onDocking() {
      this.docking = true;
    },

    submit() {
      this.$refs.dockingForm.validate(async (valid) => {
        if (!valid) {
          return;
        }

        this.dockingForm.userId = this.userId;
        this.dockingForm.achievementId = this.id;
        const result = await this.$http({
          url: "/achievementTransform/sendAchieveApply",
          method: "POST",
          params: this.dockingForm,
        });

        if (result.data.提交成功 == true) {
          this.docking = false;
          this.$toast("提交成功");
          this.getSchoolList();
        } else {
          this.$toast(result.data.msg);
        }
      });
    },

    // 图片预览
    onImage(index) {
      ImagePreview({
        images: this.imgList,
        startPosition: index,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.index-box {
  position: relative;
  .indexTopBox {
    width: 95vw;
    height: 85vh;
    margin-left: 2.5vw;
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    .imageListCardVideo {
      position: relative;
    }
    .imageListCardVideo :nth-child(2) {
      text-align: left;
      font-size: 1.1rem;
      font-weight: 600;
    }
    .cssName {
      margin-top: 10px;
    }
    .imageListCardVideo :nth-child(3) {
      text-align: left;
      font-size: 0.9rem;
      font-weight: 500;
      margin-top: 5px;
      color: #818181;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .imageListCardVideo :nth-child(4) {
      text-align: left;
      font-size: 0.9rem;
      font-weight: 500;
      margin-top: 5px;
      color: #818181;
    }
    .imageListCardVideo :nth-child(5) {
      margin-top: 3px;
      flex-direction: row;
      display: flex;
      align-items: center;
      div {
        font-size: 0.9rem;
        font-weight: 500;
        color: #818181;
        margin-top: 2px;
      }
    }

    .imageListCardVideo :nth-child(5) > img:first-child {
      width: 13px;
      height: 10px;
      margin-right: 5px;
      padding-top: 3px;
    }

    .imageListCardVideo :nth-child(6) {
      width: 100%;
      height: 2px;
      background: #dbdbdb;
      margin-top: 10px;
    }

    .imageListCardVideo :nth-child(7) {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .divn-o {
        width: 3px;
        height: 15px;
        background: #077472;
      }
      .divn-t {
        font-size: 14px;
        font-weight: 500;
        margin-left: 5px;
        line-height: 15px;
        margin-top: 0px;
      }
    }

    .imageListCardVideo :nth-child(8) {
      background: #fff;
      border-radius: 10px;
      width: 98%;
      margin-top: 5px;
      font-size: 16px;
      font-weight: 500;
      line-height: 25px;
      color: #747474;
      text-indent: 2ch;
      text-align: justify;
    }

    .imageListCardVideo :nth-child(9) {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .divn-o {
        width: 3px;
        height: 15px;
        background: #077472;
      }
      .divn-t {
        font-size: 14px;
        font-weight: 500;
        margin-left: 5px;
        line-height: 15px;
        margin-top: 0px;
      }
    }

    .imageListCardVideo > .qiyeIm-t {
      margin: 10px 0px 0px 0;
      display: flex;
      flex-direction: row;
    }

    .card_tail {
      width: 95vw;
      height: auto;
      border-radius: 10px;
      background-color: #ffffff;
      margin-top: 10px;
      padding: 5px 0 5px 0;
      bottom: 20px;
      .card_tail_content {
        display: flex;
        font-size: 1rem;
        font-weight: 500;
        line-height: 25px; //行间距
        color: #747474;
        text-indent: 4ch; //首行缩进
        text-align: justify; //两端对齐
        padding: 0 1rem 0 1rem;
        // height: auto;
      }
    }
  }
  .indexBtn {
    position: fixed;
    width: 100vw;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #00706e;
    color: #fff;
    margin-top: 30px;
    bottom: 0px;
  }

  .qiyeImg {
    display: flex;
    width: 99%;
    border-radius: 1rem;
    height: 15rem;
    margin-top: 10px;
    border: 1px solid #dbdbdb;
    image-rendering: -webkit-optimize-contrast;
  }

  .cgImg {
    width: 100px;
    height: 100px;
    bottom: 5px;
    overflow-x: auto;
    margin-right: 5px;
    image-rendering: -webkit-optimize-contrast;
  }

  .activeDetailsDiv {
    padding-top: 5px;
    width: 85vw;
    padding-right: 20px;
    overflow-x: scroll;
    overflow-y: hidden;
  }

  .activeDetailsDiv::-webkit-scrollbar {
    display: none;
  }

  .activeDetails {
    background-color: white;
    // width: 80px;
    margin: 5px;
    border-radius: 15px;
    // border: 1px solid #e1e1e1;
    white-space: nowrap;
  }

  .activeDetails-fh {
    // width: 80px;
    margin: 5px;
    float: left;
    border-radius: 15px;
  }

  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clearfix {
    *zoom: 1;
  }

  .clearfix-fh:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clearfix-fh {
    *zoom: 1;
  }
  .schoolImg {
    position: relative;
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    // margin: 8px;
    border: 1px solid #ededed;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
}
.formDivBtnDiv {
  margin-bottom: 20px;

  .formDivBtn {
    width: 90%;
    border: 0;
    margin-left: 5%;
    border-radius: 30px;
    font-size: 1.2rem;
    color: white;
    font-weight: bold;
    padding: 10px 0;
    background: linear-gradient(270deg, #00706e, #00706e);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Achievement.vue